/**
 * Composable pour gérer les options de lieu de formation
 * Uniformise l'ordre et la structure des options dans toute l'application
 */

/**
 * Retourne les options de lieu de formation dans l'ordre : INTRA, INTER, LOCATION
 * @param {Object} selectedFormation - La formation sélectionnée (optionnel)
 * @param {string} clientType - Le type de client ('particulier' ou 'professionnel')
 * @returns {Array} Tableau d'objets { value, label, condition }
 */
export function getFormationLieuOptions(selectedFormation = null, clientType = null) {
  // Pour les particuliers, uniquement INTER est disponible
  if (clientType === 'particulier') {
    return [
      {
        value: 'INTER',
        label: 'Inter - dans nos centres de formation',
        condition: true
      }
    ]
  }

  // Pour les professionnels, toutes les options selon la formation
  const options = [
    {
      value: 'INTRA',
      label: 'Intra - dans les locaux de votre établissement',
      condition: true // Toujours affiché
    },
    {
      value: 'INTER',
      label: 'Inter - dans nos centres de formation',
      condition: selectedFormation && selectedFormation.INTER && selectedFormation.INTER.toUpperCase() === 'OUI'
    },
    {
      value: 'LOCATION',
      label: 'Location d\'une salle de formation',
      condition: true // Toujours affiché
    }
  ]

  return options.filter(opt => opt.condition)
}

/**
 * Retourne les options de lieu de formation pour les filtres (liste)
 * @returns {Array} Tableau d'objets { value, label }
 */
export function getFormationLieuFilterOptions() {
  return [
    { value: 'INTRA', label: 'Intra-entreprise' },
    { value: 'INTER', label: 'Inter-entreprise' },
    { value: 'LOCATION', label: 'Location de salle' }
  ]
}

